import * as Yup from 'yup';
import { FormErrorMessages, nameSchema } from 'utils/formValidation';

export const addPersonStakeHolderSchema = () =>
    Yup.object().shape({
        firstname: nameSchema,
        lastname: nameSchema,
        phone: Yup.string()
            .matches(/^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/, FormErrorMessages.phone_invalid)
            .optional(),
        email: Yup.string()
            .email(FormErrorMessages.email_invalid)
            .optional(),
        address: Yup.object({
            address: Yup.string().min(3, FormErrorMessages.min_characters).max(200, FormErrorMessages.max_characters).optional(),
            address_add: Yup.string()
                .min(3, FormErrorMessages.min_characters)
                .max(200, FormErrorMessages.max_characters)
                .optional(),
            city: Yup.string().min(3, FormErrorMessages.min_characters).max(200, FormErrorMessages.max_characters).optional(),
            zipcode: Yup.string()
                .matches(/^\d{5}$/, FormErrorMessages.zipcode_invalid)
                .optional(),
            country: Yup.string().min(3, FormErrorMessages.min_characters).max(200, FormErrorMessages.max_characters).optional()
        }).optional()
    });

